import { atom } from "jotai";

const userLocationAtom = atom({
  lat: null,
  lng: null,
  address: null,
  city: null,
  state: null,
});

export default userLocationAtom;
